// extracted by mini-css-extract-plugin
module.exports = {"table":"OrderDetails_table__Dpgqr"};